import styled from 'styled-components';

export const ComponentAlert = styled.div.attrs(props => ({
    className: `component-alert alert alert-${props.type}`,
}))`
    border: 0;
    margin-top: 3rem;
    padding: 1.5rem;
    text-align: center;
`;
